export const DEFAULT_ZOOM = 5;

const processMapViewConfigs = ({
  currentUser,
  map_visible: mapVisible,
  map_center_location: mapCenterLocation,
  map_center_type: mapCenterType,
  map_zoom_level: mapZoomLevel,
  map_view_settings: mapViewSettings,
  location,
}) => {
  // Waiting for a back-end fix, the value saved and send back is "0" or "1" but not true/false
  const mapInitiallyVisibleValue = mapVisible;
  const isMapInitiallyDisplayed = !!(
    mapInitiallyVisibleValue === '1' || mapInitiallyVisibleValue === true
  );
  const userLastLocation = currentUser?.last_location;
  const networkCustomLocation = mapCenterLocation;
  let initialCenter;
  let initialZoom;

  if (
    mapCenterType === 'last_user_location' &&
    userLastLocation?.lat &&
    userLastLocation?.lng
  ) {
    initialCenter = [userLastLocation?.lat, userLastLocation?.lng];
    initialZoom = DEFAULT_ZOOM;
  } else if (
    mapCenterType === 'custom_network_location' &&
    networkCustomLocation?.lat &&
    networkCustomLocation?.lng
  ) {
    initialCenter = [networkCustomLocation?.lat, networkCustomLocation.lng];
    initialZoom =
      (mapZoomLevel && Number.parseInt(mapZoomLevel, 10)) || DEFAULT_ZOOM;
  } else if (location) {
    initialCenter = [location?.lat, location?.lng];
    initialZoom = DEFAULT_ZOOM;
  }

  // We always display the toggle, but we're hiding the Google Map (and so the toggle) from China only.
  switch (mapViewSettings) {
    case 'user_defined':
      return {
        isMapInitiallyDisplayed,
        userCanToggleMap: !window.is_from_china,
        initialCenter,
        initialZoom,
      };
    case 'always_shown':
      return {
        isMapInitiallyDisplayed: true,
        userCanToggleMap: false,
        initialCenter,
        initialZoom,
      };
    // eslint-disable-next-line default-case-last
    default:
    case 'always_hidden':
      return {
        isMapInitiallyDisplayed: false,
        userCanToggleMap: false,
      };
  }
};

export default processMapViewConfigs;
